<template>
    <el-row>
        <el-card class="box-card">
            <el-form>
                <el-form-item >
                    <el-form-item label="订单编号" class="form-item" label-width="70px">
                        {{ orderInfo.orderNo }}
                    </el-form-item>
                    <el-form-item label="订单状态" class="form-item" label-width="70px">
                        {{ getStatusName(orderInfo.waybillStatus) }}
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="制单人" class="form-item" label-width="70px">
                        {{ orderInfo.waybillUser }}
                    </el-form-item>
                    <el-form-item label="配货方式" class="form-item" label-width="70px">
                        {{ orderInfo.waybillMode }}
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="收货门店" class="form-item" label-width="70px">
                        {{ orderInfo.storeCode }}/{{ orderInfo.storeName }}
                        
                    </el-form-item>
                </el-form-item>
            </el-form>
        </el-card>
    </el-row>
</template>

<script>
import { getPrepareList,Mod_StockStatus_Options } from "@/modules/server-api/prepare/prepare";
export default {
    name: "orderInfo",
    props:{
        orderInfo: {
            type: Object
        }
    },
    data(){
        return {
            stockStatus: Mod_StockStatus_Options, //库存状态
        }
    },
      methods:{
        //获取状态名称:没有的返回待入库
    getStatusName(waybillStatus) {
      let resStatus = this.stockStatus.filter((item) => item.id == waybillStatus);
      console.log('8888状态',waybillStatus);
      let statusName =
        resStatus.length > 0
          ? resStatus[0].label
          : Mod_StockStatus_Options[1].label;
      return statusName;
    },
      }
}
</script>

<style scoped>
.form-item {
    float: left;
    width: 300px;
}
</style>